import React, { useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { CgGitFork } from 'react-icons/cg';
import { CgBriefcase } from 'react-icons/cg';
import {
	AiFillStar,
	AiOutlineHome,
	AiOutlineFundProjectionScreen,
	AiOutlineUser,
} from 'react-icons/ai';

import { CgFileDocument } from 'react-icons/cg';

function NavBar() {
	const [expand, updateExpanded] = useState(false);
	const [navColour, updateNavbar] = useState(false);

	useEffect(() => {
		function scrollHandler() {
			updateNavbar(window.scrollY >= 20);
		}

		scrollHandler();
		window.addEventListener('scroll', scrollHandler, { passive: true });

		return () => {
			window.removeEventListener('scroll', scrollHandler);
		};
	}, []);

	return (
		<Navbar
			expanded={expand}
			fixed='top'
			expand='md'
			className={navColour ? 'sticky' : 'navbar'}
		>
			<Container>
				<Navbar.Brand as={Link} to='/' className='d-flex navbar-brand-text'>
					<span className='brand-mark'>Z</span>
					<span className='brand-name'>Portfolio</span>
				</Navbar.Brand>
				<Navbar.Toggle
					aria-controls='responsive-navbar-nav'
					onClick={() => {
						updateExpanded(expand ? false : 'expanded');
					}}
				>
					<span></span>
					<span></span>
					<span></span>
				</Navbar.Toggle>
				<Navbar.Collapse id='responsive-navbar-nav'>
					<Nav className='ms-auto' defaultActiveKey='#home'>
						<Nav.Item>
							<Nav.Link as={Link} to='/' onClick={() => updateExpanded(false)}>
								<AiOutlineHome style={{ marginBottom: '2px' }} /> Home
							</Nav.Link>
						</Nav.Item>

						<Nav.Item>
							<Nav.Link
								as={Link}
								to='/about'
								onClick={() => updateExpanded(false)}
							>
								<AiOutlineUser style={{ marginBottom: '2px' }} /> About
							</Nav.Link>
						</Nav.Item>

						<Nav.Item>
							<Nav.Link
								as={Link}
								to='/project'
								onClick={() => updateExpanded(false)}
							>
								<AiOutlineFundProjectionScreen
									style={{ marginBottom: '2px' }}
								/>{' '}
								Projects
							</Nav.Link>
						</Nav.Item>

						<Nav.Item>
							<Nav.Link
								as={Link}
								to='/experience'
								onClick={() => updateExpanded(false)}
							>
								<CgBriefcase style={{ marginBottom: '2px' }} /> Experience
							</Nav.Link>
						</Nav.Item>

						<Nav.Item>
							<Nav.Link
								as={Link}
								to='/resume'
								onClick={() => updateExpanded(false)}
							>
								<CgFileDocument style={{ marginBottom: '2px' }} /> Resume
							</Nav.Link>
						</Nav.Item>

						<Nav.Item className='fork-btn'>
							<Button
								href='https://github.com/Zahooruddin-dev/React-Portfolio'
								target='_blank'
								className='fork-btn-inner'
							>
								<CgGitFork style={{ fontSize: '1.2em' }} />{' '}
								<AiFillStar style={{ fontSize: '1.1em' }} />
							</Button>
						</Nav.Item>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
export default NavBar;
